module.exports = __webpack_public_path__ + "img/nlc2.79cd5e5b.svg";